import { render, staticRenderFns } from "./ExportProductAds.vue?vue&type=template&id=1570cd2f&scoped=true"
import script from "./ExportProductAds.vue?vue&type=script&lang=js"
export * from "./ExportProductAds.vue?vue&type=script&lang=js"
import style0 from "./ExportProductAds.vue?vue&type=style&index=0&id=1570cd2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1570cd2f",
  null
  
)

export default component.exports